<template>
    <div id="app" class="d-flex flex-column min-vh-100">
      <main class="flex-fill">
        <router-view />
      </main>
     
    </div>
  </template>
  
  <script>
  import utilsService from '@/api/utilsService';

  export default {
    name: 'App',
    mounted() {
      this._handleSessionSync = () => {
        const result = utilsService.syncSessionFromShared();
        if (result === 'cleared' && this.$route.name !== 'login') {
          this.$router.replace({ name: 'login' }).catch(() => {});
        } else if (result === 'adopted' && this.$route.name === 'login') {
          const role = (localStorage.getItem('user-role') || '').toLowerCase().trim();
          const target = role === 'comprador' ? 'visor-transacciones' : 'dashboard-master';
          this.$router.replace({ name: target }).catch(() => {});
        }
      };

      this._onVisibility = () => {
        if (document.visibilityState === 'visible') this._handleSessionSync();
      };

      window.addEventListener('focus', this._handleSessionSync);
      document.addEventListener('visibilitychange', this._onVisibility);

      if ('cookieStore' in window) {
        this._onCookieChange = () => this._handleSessionSync();
        window.cookieStore.addEventListener('change', this._onCookieChange);
      } else {
        this._sessionInterval = setInterval(() => {
          if (document.visibilityState === 'visible') this._handleSessionSync();
        }, 2000);
      }
    },
    beforeDestroy() {
      window.removeEventListener('focus', this._handleSessionSync);
      document.removeEventListener('visibilitychange', this._onVisibility);
      if (this._onCookieChange && 'cookieStore' in window) {
        window.cookieStore.removeEventListener('change', this._onCookieChange);
      }
      if (this._sessionInterval) clearInterval(this._sessionInterval);
    },
  }
  </script>

<style>
.header {
    position: inherit;
}
footer.footer.px-4 {
    bottom: 0;
    position: fixed;
}
.main-content {
    background: #fff;
}
a.nav-link.active {
    background: #5e72e4;
    color: #fff !important;
    border-radius: 6px;
    margin-left: 10px;
}

a.nav-link.router-link-exact-active.active i::before {
    color: #fff;
}

button.btn.btn-create-new.btn-custom {
    margin-top: 10px;
    border: solid 0.5px;
}

.divisor {
    background: #5e72e4;
    color: #fff !important;
    border-radius: 6px;
    padding: 10px 20px;
    margin-bottom: 10px;
}


button.btn.btn-sm.btn-action.btn-primary {
    width: max-content;
}

button.btn.btn-create-new.btn-sm.btn-action.danger.btn-primary {
    background: #cb0b0b;
    border-color: red;
}
.btn-green {
    background-color: #c7fff7;
    border-color: #c7fff7;
    color: #00b69b;
}
.btn-green:hover{
    background-color: #00b69b;
    border-color: #00b69b;
    color: #fff;
}

 .btn-blue {
    background-color: #c7e9ff;
    border-color: #c7e9ff;
    color: #007acc;
}
.btn-blue:hover{
    background-color: #007acc;
    border-color: #007acc;
    color: #fff;
}

a.nav-link.active i::before {
    color: #fff;
}
.el-select .el-input__inner {
    font-size: 0.7rem !important;
    border-radius: 6px;;
}
input#pageSize {
    border-radius: 6px;
    width: 70px;
    margin-left: 10px;
}
</style>
